import { inject, Service } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { placedBoxesActions } from '../actions/placed-boxes.actions';
import { selectBoxes, selectContents, selectHasMore, selectLoaded, selectLoading, selectPage, selectSaving } from '../selectors/placed-boxes.selector';

@Service()
export class PlacedBoxesFacade {
    private readonly store = inject(Store);
    private readonly actions = inject(Actions);

    readonly boxes = this.store.selectSignal(selectBoxes);
    readonly page = this.store.selectSignal(selectPage);
    readonly hasMore = this.store.selectSignal(selectHasMore);
    readonly contents = this.store.selectSignal(selectContents);
    readonly loaded = this.store.selectSignal(selectLoaded);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly saving = this.store.selectSignal(selectSaving);
    readonly closed$ = this.actions.pipe(ofType(placedBoxesActions.closeBoxSuccess));
    readonly loadError$ = this.actions.pipe(ofType(placedBoxesActions.loadBoxesError));
    readonly boxLoaded$ = this.actions.pipe(ofType(placedBoxesActions.loadBoxSuccess));
    readonly boxLoadError$ = this.actions.pipe(ofType(placedBoxesActions.loadBoxError));
    readonly lockError$ = this.actions.pipe(ofType(placedBoxesActions.lockBoxError));

    loadBoxes(stationCode: string): void {
        this.store.dispatch(placedBoxesActions.loadBoxes({ stationCode, page: 1 }));
    }

    loadMoreBoxes(stationCode: string): void {
        this.store.dispatch(placedBoxesActions.loadBoxes({ stationCode, page: this.page() + 1 }));
    }

    loadBox(code: string): void {
        this.store.dispatch(placedBoxesActions.loadBox({ code }));
    }

    lockBox(code: string): void {
        this.store.dispatch(placedBoxesActions.lockBox({ code }));
    }

    unlockBox(): void {
        this.store.dispatch(placedBoxesActions.unlockBox());
    }

    reduceItem(code: string, ean: string): void {
        this.store.dispatch(placedBoxesActions.reduceItem({ code, ean }));
    }

    increaseItem(code: string, ean: string): void {
        this.store.dispatch(placedBoxesActions.increaseItem({ code, ean }));
    }

    closeBox(code: string): void {
        this.store.dispatch(placedBoxesActions.closeBox({ code }));
    }

    clear(): void {
        this.store.dispatch(placedBoxesActions.clear());
    }
}
